var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m464.839 174.759h-58.71v-125.42c0-4.418-3.582-8-8-8h-284.257c-4.418 0-8 3.582-8 8v125.42h-58.711c-26.005 0-47.161 21.156-47.161 47.161v134.87c0 26.005 21.156 47.161 47.161 47.161h58.711v58.71c0 4.418 3.582 8 8 8h284.257c4.418 0 8-3.582 8-8v-58.71h58.71c26.005 0 47.161-21.156 47.161-47.161v-134.87c0-26.005-21.156-47.161-47.161-47.161zm-342.967-117.42h268.257v117.42h-268.257zm268.257 397.322h-268.257v-117.42h268.257zm105.871-97.871c0 17.183-13.979 31.161-31.161 31.161h-58.71v-58.71c0-4.418-3.582-8-8-8h-284.257c-4.418 0-8 3.582-8 8v58.71h-58.711c-17.182 0-31.161-13.978-31.161-31.161v-134.87c0-17.183 13.979-31.161 31.161-31.161h417.678c17.183 0 31.161 13.979 31.161 31.161zm-344.444 14.901c0-4.418 3.582-8 8-8h192.889c4.418 0 8 3.582 8 8s-3.582 8-8 8h-192.889c-4.418 0-8-3.582-8-8zm0 48.52c0-4.418 3.582-8 8-8h192.889c4.418 0 8 3.582 8 8s-3.582 8-8 8h-192.889c-4.418 0-8-3.582-8-8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.4be8ce87a0244173a4122089006e95f2.svg";
export { ForwardRef as ReactComponent };